import { QRCodeSVG } from "qrcode.react";
import * as React from "react";
import { getPublicRuntimeConfig } from "../../config";
import { getBranchLinkForProcedure } from "../../core/branch";
import { useDidMount } from "../../core/hooks/useDidUpdate";
import logger from "../../core/logger";
import { quoteString } from "../../core/utils";
import { getUtmParameters } from "../../core/utmParameters";
import { trackGPLEvent } from "../../providers/GoogleTagManager/GoogleTagManagerProvider";
import { IProcedureDetails } from "../../typings/filterEntities";
import { NoArgCallback } from "../../typings/utils";
import Modal, { ModalCopy, ModalHeading } from "../Modal/Modal";
import styles from "./ModalSendToPhone.module.css";

interface IProps {
  procedure: IProcedureDetails;
  show: boolean;
  onHide: NoArgCallback;
}

export default function ModalSendToPhone({ procedure, show, onHide }: IProps) {
  const [branchLink, setBranchLink] = React.useState(
    `${getPublicRuntimeConfig().branchFallbackUrl}${getUtmParameters({
      procedureUid: procedure.uid,
    })}`,
  );

  useDidMount(() => {
    (async function getLink() {
      const link = await getBranchLinkForProcedure(procedure.uid, "ScanQRCode");
      setBranchLink(link);
    })().catch((err) => {
      logger.error(err);
    });
  });

  React.useEffect(() => {
    if (show) {
      trackGPLEvent("ScanQRCode", {
        action: "Download",
        category: "Procedure",
        label: procedure.uid,
      });
    }
  }, [procedure.uid, show]);

  return (
    <Modal show={show} onHide={onHide}>
      <ModalHeading>Use {quoteString(procedure.title)} for FREE!</ModalHeading>
      <ModalCopy>Scan this QR Code with your phone camera to download the application:</ModalCopy>
      <a className={styles.qrcodeWrapper} href={branchLink}>
        <QRCodeSVG
          value={branchLink}
          size={192}
          bgColor="#ffffff"
          fgColor="#1a1a1a"
          level="Q"
          imageSettings={{
            src: `${getPublicRuntimeConfig().frontendUrl}/AppIcon_256.png`,
            height: 64,
            width: 64,
            excavate: true,
          }}
        />
      </a>
    </Modal>
  );
}
